
import './page-about.css'

import htmlFrag from './page-about.frag.html'

import { loadHtmlFragment } from './load-html-fragment'
export function initPageAbout () {
  loadHtmlFragment('#section-about', htmlFrag)
}
